import './entity.less';
import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import SelectField from '../../../../shared/form-elements/select/field';
import iconAffiliate from '../../../../../assets/img/global/icon-web.svg';

import get from 'lodash/get';

const offerRowHeight = 52;
const firstOfferRowHeight = 60;

const Affiliate = ({
	className,
	type,
	parentName,
	index,
	intl,
	fields,
	placeholder,
	entityLookup,
	onToggleOffersPan,
	onFetchOffers,
	onDeleteAffiliate,
	offersAmount,
	shouldShowOffers,
	shownTargetPixelHeightsMap
}) => (
	<tr className={`entity-affiliate ${className}`} onClick={e => onToggleOffersPan(index)}>
		<td className="entity-type">
			{shouldShowOffers && offersAmount ? (
				<div
					className="vertical-line"
					style={{
						height: offersAmount
							? firstOfferRowHeight + (offersAmount - 1) * offerRowHeight + (shownTargetPixelHeightsMap[index] || 0)
							: firstOfferRowHeight
					}}
				/>
			) : null}
			<Field
				name={`${parentName}.${type}`}
				placeholder={placeholder}
				component={SelectFieldWithImage}
				image={iconAffiliate}
				multi={false}
				disabled={!!fields.get(index)}
				onChange={entity => {
					onFetchOffers(index, entity[0]);
				}}
				showLabel={false}
				options={entityLookup}
			/>
		</td>
		<td className="entity-offers">
			<span>{fields.get(index)['offer_ids'].length}</span>
		</td>
		<td className="entity-actions">
			<div className="actions__wrap">
				<span
					className="delete"
					onClick={e => {
						e.stopPropagation();
						const affiliate = get(fields.getAll()[index], 'affiliate');
						const confirmation = prompt(
							`You are going to remove ${affiliate[0].label} from this master account.\n\n` +
							`All offers and individual terms for ${affiliate[0].label} will remain the same.\n\n` +
							`Are you sure you want to proceed? Type 'yes' to confirm.`
						);
						if (confirmation && confirmation.toLowerCase() === 'yes') {
							fields.remove(index);
							onDeleteAffiliate(affiliate[0]['value']);
						}
					}}
				/>
				<span className="toggle" />
			</div>
		</td>
	</tr>
);

const SelectFieldWithImage = props => {
	return (
		<div>
			<SelectField {...props}>
				<img src={props.image} alt="affiliate img" className="select-image" />
			</SelectField>
		</div>
	);
};

SelectFieldWithImage.propTypes = {
	image: PropTypes.string
};

Affiliate.propTypes = {
	className: PropTypes.string,
	type: PropTypes.string,
	parentName: PropTypes.string,
	index: PropTypes.any,
	intl: PropTypes.func,
	fields: PropTypes.object,
	placeholder: PropTypes.string,
	entityLookup: PropTypes.func,
	onToggleOffersPan: PropTypes.func,
	onFetchOffers: PropTypes.func,
	onDeleteAffiliate: PropTypes.func,
	offersAmount: PropTypes.number,
	shouldShowOffers: PropTypes.bool,
	shownTargetPixelHeightsMap: PropTypes.object
};

export default Affiliate;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliates/components/profile/affiliates/affiliate.js